import { combineReducers } from 'redux'
import { reducer as authReducer, reducerKey as authReducerKey } from './auth'
import {
  reducer as workOrdersReducer,
  reducerKey as workOrdersReducerKey,
} from './workOrders'
import {
  reducer as managerReducer,
  reducerKey as managerReducerKey,
} from './manager'

const reducerKey = 'root'

const reducer = combineReducers({
  [authReducerKey]: authReducer,
  [workOrdersReducerKey]: workOrdersReducer,
  [managerReducerKey]: managerReducer,
})

export { reducer, reducerKey }
